/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
/** @jsxImportSource solid-js */

import { customElement } from 'solid-element';
import AuthImage, { AuthImageProps } from './AuthImage';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-auth-image': Partial<HTMLElement> &
        AuthImageProps &
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Partial<{ ref: any }>;
    }
  }
}

export function defineSolidAuthImage(): void {
  customElement(
    'tc-auth-image',
    {
      // Include ALL component properties with default values here
      // This is CRITICAL for proper property synchronization
      src: '',
      className: '',
      errImg: '',
      onClick: undefined,
      asBackground: false,
      alt: '',
      style: {},
      imageProps: {},
      accessToken: '',
      updateForFeatureBranch: undefined,
    },
    AuthImage
  );
}
